import { css } from "@emotion/react";

export const addStyles = ({ theme }) => css`
  padding: 6px 10px;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    padding: 20px;
  }
`;
